import type { ReactNode } from 'react'
import { AuthContext } from './AuthContext'
import { useAuth } from './useAuth'

export interface AuthProviderProps {
  children: ReactNode
  bffBaseUrl?: string
}

export function AuthProvider({ children, bffBaseUrl = '' }: AuthProviderProps) {
  const contextValue = useAuth({ bffBaseUrl })

  return (
    <AuthContext value={contextValue}>
      {children}
    </AuthContext>
  )
}
